import { Button } from "@tokenterminal/core/ui/button/Button"
import { sendEvent } from "modules/analytics"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { GLOBAL_COOKIE_BANNER_CLASSNAME } from "./constants"
import { createConsent } from "./utils"

export function CookieBanner() {
  const router = useRouter()
  const [isMounted, setIsMounted] = useState(false)
  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (router.pathname.includes("/embed")) {
    return null
  }

  return (
    <div
      className="fixed bottom-0 left-0 right-0 border border-solid border-border-default border-b-0 p-4 rounded-tl-2xl rounded-tr-2xl overflow-hidden text-primary hidden z-[var(--banner-z-index)] [.show-cookiebanner_&]:block bg-bg-surface"
      id="cookie-banner"
      style={{
        // @ts-ignore
        "--banner-z-index": Number.MAX_SAFE_INTEGER,
      }}
    >
      <div className="relative mx-auto justify-between flex md:flex-row flex-col md:items-center gap-4">
        <p className="text-sm">
          We use some essential cookies to make this website work. We&apos;d
          like to set additional cookies to understand how you use
          tokenterminal.com and remember your settings.{" "}
          <a
            href="https://docs.tokenterminal.com/docs/privacy-notice"
            className="underline text-sm text-fg-secondary"
          >
            Learn more
          </a>
        </p>
        <div className="flex md:flex-row flex-col gap-2 md:justify-between flex-shrink-0">
          <Button
            className="w-full md:w-auto"
            variant="solid"
            color="success"
            onPress={() => {
              createConsent(true, sendEvent)
              document.body.classList.remove(GLOBAL_COOKIE_BANNER_CLASSNAME)
            }}
            isDisabled={!isMounted}
          >
            Allow all
          </Button>
          <Button
            className="w-full md:w-auto"
            data-consent="reject"
            isDisabled={!isMounted}
            onPress={() => {
              createConsent(false, sendEvent)
              document.body.classList.remove(GLOBAL_COOKIE_BANNER_CLASSNAME)
            }}
          >
            Disable all
          </Button>
        </div>
      </div>
    </div>
  )
}
